<div class="comments-container">
  <div #messageSection class="message-section" *ngIf="_sectionMessages">
    <p-card *ngFor="let message of _sectionMessages" class="message-card">
      <p-header class="message-header">
        <div>
          <img [src]="getIconSrc(message)" />
          <p class="message-author">{{ message.author }}</p>
        </div>
        <span class="message-time">{{ message.created_on | date : 'medium' }}</span>
      </p-header>
      <span [innerHTML]="message.content"></span>
      <p-footer></p-footer>
    </p-card>
    <div *ngIf="!_sectionMessages.length" class="no-data-available">{{ 'review-section.no-messages-for-section-yet' | translate }}</div>
  </div>

  <div class="message-input-section">
    <app-review-message-input
      *ngIf="allowCreateMessage"
      [applicationId]="applicationId"
      [entityId]="entityId"
      [sectionId]="sectionId"
      (messageAdded)="onMessageAdded()"></app-review-message-input>
  </div>
</div>
